import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {epicErrorHandler} from '../../../core-utilities/rx-utils';
import {assignUserProfileToModel, assignUserToModel} from '../actions';
import {logger} from './logger';

export const epics = [
  onAssignUser,
];

onAssignUser.$inject = [
  'PersonDomain',
];

export function onAssignUser(action$, store, dependencies) {
  return action$.ofType(assignUserToModel.TYPE)
    .switchMap(action =>
      action.payload.user
        ? Observable.fromPromise(dependencies.PersonDomain.$get(getId(action.payload.user)).catch(err => null))
          .map(userProfile => assignUserProfileToModel({userProfile}))
        : Observable.of(assignUserProfileToModel({userProfile: null}))
    )
    .catch(epicErrorHandler(logger, 'onAssignUser'));
}



// WEBPACK FOOTER //
// ./src/js/app/model/epics/onAssignUser.js